import { useGameDispatch } from '../../store/global-context';
import { useGameStatusStore } from '../../store/zustand/useGameStatusStore';
import styles from './styles.module.scss';
import { Generator, GUIActions, Purchasable, UnitType, UpgradeActions } from '../../types/game-types';
import { useItemCost } from '../../store/hooks/useItemCost';
import { Icon } from '../Icon';
import { useEffect } from 'react';
import { PlayerEvents } from '@game-libs/models';
import { EventsManager } from '@game-libs/events-manager';

export const PurchaseableTemplate = ({ item, children }: { item: Purchasable; children: React.ReactNode }) => {
  const stunEffectTickDurationRemaining = useGameStatusStore((s) => s.stunEffectTickDurationRemaining);
  const dispatch = useGameDispatch();
  const [cost, amountToBuy] = useItemCost(item);
  const { emit } = EventsManager();

  const tooExpensive = amountToBuy === 0;
  const isDisabled =
    tooExpensive ||
    (item.purchaseLimit && item.purchased >= item.purchaseLimit) ||
    stunEffectTickDurationRemaining > 0;

  const purchaseActionType = item.type !== UnitType.UPGRADE ? GUIActions.BUY_GENERATOR : UpgradeActions.BUY_UPGRADE;

  const isJustUnlocked = !tooExpensive && item.type !== UnitType.UPGRADE && (item as Generator).owned === 0;

  const handleClick = () => {
    if (tooExpensive) return;

    dispatch({
      type: purchaseActionType,
      payload: { id: item.id, cost, amountToBuy },
    });
  };

  useEffect(() => {
    if (!isJustUnlocked) return;

    emit(PlayerEvents.UNLOCK_ITEM, { item });
  }, [isJustUnlocked]);

  return (
    <div
      onClick={handleClick}
      className={`hover-target ${styles.purchaseableContainer} ${isDisabled ? styles.disabled : ''} ${styles[item.type]}`}
    >
      {isJustUnlocked && (
        <div className={styles.buyMeArrow}>
          <Icon iconId={'buy_me_arrow'} />
        </div>
      )}
      {children}
    </div>
  );
};
